import { AppBar, IconButton, styled } from '@mui/material';
import { drawerWidth } from '../Navigation/styled';
import pallet from '../../../layouts/pallet';

interface StyledAppBarProps {
  open: boolean;
}

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'open'
})<StyledAppBarProps>(({ open, theme }) => ({
  position: 'fixed',
  width: `calc(100% - ${open ? drawerWidth : 60}px)`,
  marginLeft: `${open ? drawerWidth : 60}px`,
  backgroundColor: theme.palette.common.white,
  boxShadow: 'none',
  borderBottom: `1px solid ${pallet.borderBackground}`,
  transition: 'width 0.3s, margin 0.3s',
  minHeight: '80px'
}));

const IconButtonContainer = styled(IconButton)(({ theme }) => ({
  color: 'inherit',
  marginRight: theme.spacing(2)
}));

export { StyledAppBar, IconButtonContainer };
